import axios from "axios";
import { API_BASE_URL } from "../../../config";

export async function fetchLeaderboardHistory({ page = 1, limit = 10 } = {}) {
  const params = new URLSearchParams();
  params.set("page", String(page));
  params.set("limit", String(limit));

  const { data } = await axios.get(
    `${API_BASE_URL}/api/leaderboard/history?${params.toString()}`
  );
  return data;
}
